import React, { useState } from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Playwrightpages.module.css";
import logo from "../../assets/logo.png";

const PwLocators = () => {
  const [feedback, setFeedback] = useState({ index: -1, text: "" });

  const show = (idx, text) => () => setFeedback({ index: idx, text });

  const sections = [

    // =====================================================
    // 1️⃣ getByRole
    // =====================================================
    {
      heading: "getByRole()",
      ui: (
        <div>
          <button className={`${styles.btn} ${styles.primary}`} onClick={show(0, 'You Clicked me!')}>
            Click Me!
          </button>
          {feedback.index === 0 && <div className={styles.clickMessage}>{feedback.text}</div>}
        </div>
      ),
      code: `// Locate button using role
await page.getByRole('button', { name: 'Click Me!' }).click();`
    },

    // =====================================================
    // 2️⃣ getByText
    // =====================================================
    {
      heading: "getByText()",
      ui: (
        <div>
          <button className={`${styles.btn} ${styles.primary}`} onClick={show(1,'Clicked Bspark Software Technologies!')}>
           Bspark Software Technologies
          </button>
          {feedback.index === 1 && <div className={styles.clickMessage}>{feedback.text}</div>}
        </div>
      ),
      code: `// Locate using visible text
await page.getByText('Bspark Software Technologies').click();`
    },

    // =====================================================
    // 3️⃣ getByLabel & getByPlaceholder
    // =====================================================
    {
      heading: "getByLabel() & getByPlaceholder()",
      ui: (
        <div>
          <div className={styles.inputGroup}>
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              placeholder="Enter username"
              className={styles.input}
              onClick={show(2, 'Input clicked')}
            />
          </div>
          {feedback.index === 2 && <div className={styles.clickMessage}>{feedback.text}</div>}
        </div>
      ),
      code: `// Locate by label
await page.getByLabel('Username').fill('John');

// Locate by placeholder
await page.getByPlaceholder('Enter username').fill('John');`
    },

    // =====================================================
    // 4️⃣ getByAltText
    // =====================================================
    {
      heading: "getByAltText()",
      ui: (
        <div>
          <img
            src={logo}
            alt="company logo"
            className={styles.testImage}
            style={{ cursor: "pointer" }}
            onClick={show(3, '✅ Image Clicked Successfully!')}
          />
          {feedback.index === 3 && <div className={styles.clickMessage}>{feedback.text}</div>}
        </div>
      ),
      code: `// Locate image using alt text
    await page.getByAltText('company logo').click();`
    },

    // =====================================================
    // 5️⃣ getByTitle
    // =====================================================
    {
      heading: "getByTitle()",
      ui: (
        <div>
          <button
            title="Title Based Button"
            className={`${styles.btn} ${styles.success}`}
            onClick={show(4, 'Title button clicked')}
          >
            Hover Me
          </button>
          {feedback.index === 4 && <div className={styles.clickMessage}>{feedback.text}</div>}
        </div>
      ),
      code: `// Locate using title attribute
await page.getByTitle('Title Based Button').click();`
    },

    // =====================================================
    // 6️⃣ getByTestId
    // =====================================================
    {
      heading: "getByTestId()",
      ui: (
        <div>
          <button
            data-testid="testid-button"
            className={`${styles.btn} ${styles.primary}`}
            onClick={show(5, 'TestId button clicked')}
          >
            TestId Button
          </button>
          {feedback.index === 5 && <div className={styles.clickMessage}>{feedback.text}</div>}
        </div>
      ),
      code: `// Locate using test id
await page.getByTestId('testid-button').click();`
    }

  ];

  return (
    <PlaywrightTemplate title="LOCATORS" sections={sections} />
  );
};

export default PwLocators;